module.exports = __webpack_public_path__ + "static/media/mongolia_mototurismo_1.eaa6e6c0.jpg";